import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import {
  SbeSmsApiService,
  type BalanceResponseDto,
  type ListOrgMemberBalancesResponseDto,
  type OrgCreditTransferBodyDto,
  type OrgCreditTransferResultDto,
} from '@sbe-spinoff-client/sbe-sms-api';

/**
 * 전부 org 라우트라 URL이 `/orgs/:orgId/...`이고, `spinoffAuthInterceptor`가
 * `resolveOrgScopedId`로 자동 인식해 org access token을 붙인다(2026-07-23).
 */
@Injectable({ providedIn: 'root' })
export class OrgCreditsApiService {
  private readonly api = inject(SbeSmsApiService);

  getOrgBalance(orgId: string): Observable<BalanceResponseDto> {
    return this.api.orgBalanceControllerGetBalance<BalanceResponseDto>(orgId);
  }

  listMemberBalances(orgId: string): Observable<ListOrgMemberBalancesResponseDto> {
    return this.api.orgCreditsDistributionControllerListMembers<ListOrgMemberBalancesResponseDto>(orgId);
  }

  distribute(orgId: string, body: OrgCreditTransferBodyDto): Observable<OrgCreditTransferResultDto> {
    return this.api.orgCreditsDistributionControllerDistribute<OrgCreditTransferResultDto>(orgId, body);
  }

  reclaim(orgId: string, body: OrgCreditTransferBodyDto): Observable<OrgCreditTransferResultDto> {
    return this.api.orgCreditsDistributionControllerReclaim<OrgCreditTransferResultDto>(orgId, body);
  }
}
